import { createAsyncThunkFromFetch } from 'src/store/utils';
import { FetchAboutParams, FetchAboutResponse } from './about.types';
import { getHotelAbout } from './about.api';

export const fetchAbout = createAsyncThunkFromFetch<
  FetchAboutResponse,
  FetchAboutParams
>('about/fetchAbout', getHotelAbout);
